var siteConfig  = {
    "cloudRoot": "https://storage.googleapis.com/assets.mcomnyapps.net/prom/",
    "cloudVersion": "2026-03",
    "siteName": "prom",
    "assets_dir": "https://storage.googleapis.com/assets.mcomnyapps.net/prom/2026-03"
}